import { useDispatch } from "react-redux";
import DeleteActionIcon from "../../../../../components/icons/DeleteActionIcon";
import TextWrapper from "../../../../../components/textWrapper/TextWrapper";
import { showConfirmationModal } from "../../../../../features/confirmationModal/ConfirmationModalSlice";
import styles from "./regionOneImage.module.css";

const RegionOneImage = ({ path, id, name }) => {
  const dispatch = useDispatch();

  const handleDeleteImage = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من حذف الصورة ؟",
        data: id,
        actionType: "deleteRegionImage",
      })
    );
  };

  return (
    <div className={styles.oneImageContainer}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textSmall">{name}</TextWrapper>
      </div>
      <div className={styles.regionImageWrapper}>
        <img src={path} alt={name} className={styles.regionImage} />
      </div>
      <button
        type="button"
        className={styles.deleteImageWrapper}
        onClick={handleDeleteImage}
      >
        <DeleteActionIcon className={styles.svgIcon} />
        <TextWrapper textStyle="textXSmall">حذف الصوره</TextWrapper>
      </button>
    </div>
  );
};

export default RegionOneImage;
